module.exports = __webpack_public_path__ + "static/media/trophy.52a62586.svg";